import { useState, useEffect } from "react";
import InputField from "./InputField";
import { fetchPublications, resetPublications } from "../../store/search-actions";
import { useSelector, useDispatch } from "react-redux";
import SearchLoader from "./SearchLoader";
import DeleteIcon from "./DeleteIcon";
import FacetIcon from "./FacetIcon";

const PublicationsSearch = (props) => {
  const dispatch = useDispatch();
  // states
  const [isOpen, setIsOpen] = useState(false);
  const [inputValue, setInputValue] = useState({ searchText: "" });
  const { searchText } = inputValue;
  const publications = useSelector((state) => state.search.publications);
  const loadingPublications = useSelector((state) => state.search.loadingPublications);

  // methods
  const handleChange = (e) => {
    const { name, value } = e.target;
    setInputValue((prev) => ({
      ...prev,
      [name]: value
    }));
  };
   const checkIfActive = (f) => {
    if(!props.selections['publications']) { 
      return false 
    } else {
      return props.selections['publications'].includes(f)
    }
  }
  const handleAuthor =  (val) => props.filtersHandler(props.id, val);
  useEffect(() => {
    const identifier = setTimeout(() => {
      //props.setField(inputValue.searchText)
      if (searchText.length < 1) {
        dispatch(resetPublications());
      } else {
        dispatch(fetchPublications(searchText));
      }
    }, 500);
    return () => {
      clearTimeout(identifier);
    };
    // eslint-disable-next-line
  }, [inputValue]);
  return (
    <div className="w-full border-b-[1px] border-b-black border-dotted ">
      <div className="w-full flex flex-row justify-between items-center py-5">
        <span className="font-bold uppercase text-filter-title whitespace-nowrap">{props.label}</span>
        <span className={`transition-all duration-400 cursor-pointer ${isOpen ? '-rotate-45' : ''}`} onClick={() => setIsOpen(!isOpen)}><FacetIcon/></span>
      </div>
      {isOpen ? (
        <div className="flex flex-col items-start justif-start uppercase w-full pb-2.5">
          <div className="py-2 border-[0.5px] border-black border-solid w-full rounded">
            <InputField
              className="flex growth"
              type="text"
              value={searchText}
              placeholder="Type a publication..."
              name="searchText"
              onChange={handleChange}
              noPadding={true}
            />
          </div>
          {loadingPublications ? (
            <div className="w-full flex items-center justify-center">
              <SearchLoader />
            </div>
          ) : publications.length ||  props.selections['publications']?.length ? (
            <div className="h-[150px] w-full overflow-y-auto">
              {props.selections['publications']?.length
                ?props.selections['publications']?.map((sa) => (
                    <div
                      className="cursor-pointer w-full p-2 border-[0.5px] border-b-black border-b-dotted text-left bg-primary text-white hover:opcaity-70 hover:font-bold flex flex-row items-center justify-between"
                      key={sa}
                      onClick={() => handleAuthor(sa)}
                    >
                      {sa}<DeleteIcon />
                    </div>
                  ))
                : null}

              {publications
                .filter((o) => !checkIfActive(o.toLowerCase()))
                .map((a) => (
                  <div
                    className="cursor-pointer w-full p-2 border-[0.5px] border-b-black border-b-dotted text-left hover:text-primary hover:font-bold"
                    key={a}
                    onClick={() => handleAuthor(a)}
                  >
                    {a}
                  </div>
                ))}
            </div>
          ) : null}
          {searchText.length && !publications.length ? (
            <div>Try with another publication</div>
          ) : null}
          {searchText.length < 1 ? (
            <div className="text-left">Type a publication's name</div>
          ) : null}
          <div></div>
        </div>
      ) : null}
    </div>
  );
};

export default PublicationsSearch;
